module.exports = __webpack_public_path__ + "img/drawing-board.583b0fb0.svg";